import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'cap-too-many-icp-grundstueck-requests',
  templateUrl: './too-many-icp-grundstueck-requests.component.html'
})
export class TooManyIcpGrundstueckRequestsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
